import * as Yup from "yup";

type Question = {
  options: string[];
  question_label: string;
  is_required: number;
  question_type: number;
  form_id: number;
  question_response: string | string[];
  question_id: number;
};

export const userProbationSchema = (
  questions: Question[] = [],
  surveyFormQuestionDetails: any
) => {
  let dynamicFields: Record<string, any> = {};

  if (questions && surveyFormQuestionDetails) {
    dynamicFields = questions.reduce((schema: Record<string, any>, q) => {
      const key = `question_${q.question_id}`;

      if (q.question_type === 3) {
        // Checkbox / multi-select -> array of strings
        schema[key] = Yup.array()
          .of(Yup.string())
          .test("required-if-completed", "Please select at least one option", function (value) {
            const { probationStatus } = this.parent;
            if (probationStatus === "completed" && q.is_required) {
              return Array.isArray(value) && value.length > 0;
            }
            return true; // Not required otherwise
          });
      } else if (q.question_type === 5) {
        // Multi-select with objects
        schema[key] = Yup.array()
          .of(
            Yup.object().shape({
              label: Yup.string(),
              value: Yup.string(),
            })
          )
          .test("required-if-completed", "Please select at least one option", function (value) {
            const { probationStatus } = this.parent;
            if (probationStatus === "completed" && q.is_required) {
              return Array.isArray(value) && value.length > 0;
            }
            return true;
          });
      } else {
        // Text or radio
        schema[key] = Yup.string().test(
          "required-if-completed",
          "Please select a valid option",
          function (value) {
            const { probationStatus } = this.parent;
            if (probationStatus === "completed" && q.is_required) {
              return value != null && value !== "" && value !== "NA";
            }
            return true;
          }
        );
      }

      return schema;
    }, {});
  }

  return Yup.object().shape({
    probationStatus: Yup.string().required("Probation status is required"),

    extendedDate: Yup.date()
      .nullable()
      .when("probationStatus", {
        is: (val: string) => val === "extended",
        then: (schema) =>
          schema.required("Extended date is required").typeError("Extended date is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

    probationRemark: Yup.string().required("Remark is required"),

    ...(surveyFormQuestionDetails && dynamicFields),
  });
};
